export class Plan {
  id = 0;
  floor = 0;
  url = '';

  constructor(data) {
    const { id, floor, url } = data;

    Object.assign(this, { id, floor, url });
  }
}
